import { Component, HostBinding, inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HeaderBeforeLoginComponent } from '@components/layouts/header-before-login/header-before-login.component';
import { FooterComponent } from '@components/layouts/footer/footer.component';
import { CommonModule } from '@angular/common';
import { HeaderBeforeLoginService } from '@services/services/header-before-login.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'kzn-layout-guest-sign',
  standalone: true,
  imports: [RouterOutlet, HeaderBeforeLoginComponent, FooterComponent, CommonModule],
  templateUrl: './layout-guest-sign.component.html',
  styleUrl: './layout-guest-sign.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class LayoutGuestSignComponent implements OnInit, OnDestroy {
  @HostBinding('class.layout-guest-sign--edit') get isEditPage(): boolean {
    return this.isCustomerLayout;
  }
  isCustomerLayout: boolean = false;
  isPdfViewerRoute: boolean = false;
 
  readonly backgroundStyle = `url(/assets/background.png), linear-gradient(135deg, #1e3a5f 0%, #2d5a87 40%, #1a4d6e 100%)`;

  private _activatedRoute = inject(ActivatedRoute);
  private _router = inject(Router);
  private _headerService = inject(HeaderBeforeLoginService);
  private _routeSub?: Subscription;

  ngOnInit(): void {
    this._updateFromRoute();
    this._routeSub = this._router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => this._updateFromRoute());
  }

  ngOnDestroy(): void {
    this._routeSub?.unsubscribe();
    this._headerService.setCustomerLayout(false);
  }

  private _updateFromRoute(): void {
    let route = this._activatedRoute;
    while (route.firstChild) route = route.firstChild;
    this.isCustomerLayout = route.snapshot.data?.['isCustomerLayout'] || false;
    const path = route.routeConfig?.path || '';
    this.isPdfViewerRoute = path.startsWith('sign/') || path.startsWith('view/');
    // Always show header on guest routes (sign/view/edit) irrespective of previous page state
    this._headerService.setHeaderVisible(true);
    if (this.isPdfViewerRoute && !this._headerService.headerLogo()) {
      this._headerService.updateHeaderLogo('assets/logo2.png');
    }
    if (this.isCustomerLayout) {
      this._headerService.setCustomerLayout(true);
      this._headerService.updateHeaderLogo(null);
    } else {
      this._headerService.setCustomerLayout(false);
    }
  }
}
